import React, { ReactElement, useEffect, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { classNames } from 'lib/util';

const languageNames = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
};

export default function LanguageLinks(props: {
  current: string;
  available: string[];
}): ReactElement {
  const [bestChoice, setBestChoice] = useState(undefined);

  useEffect(() => {
    const preferred =
      typeof navigator !== 'undefined'
        ? navigator.languages.map((l) => l.split('-')[0])
        : [];

    setBestChoice(preferred.filter((l) => props.available.includes(l))[0]);
  }, [props.available]);

  const path = useRouter().pathname;

  const pathWithoutLang =
    props.current !== 'en' ? path.substring(props.current.length + 1) : path;

  const alternates = props.available.filter((lang) => lang !== props.current);

  return (
    <>
      {alternates.map((lang, index) => (
        <span key={lang}>
          <Link href={(lang !== 'en' ? '/' + lang : '') + pathWithoutLang}>
            <a className={classNames(lang === bestChoice && 'bg-yellow-200')}>
              {languageNames[lang]}
            </a>
          </Link>
          {index !== alternates.length - 1 && <>&nbsp;|&nbsp;</>}
        </span>
      ))}
    </>
  );
}
